module.exports = __webpack_public_path__ + "static/dr_squatch_logo-82a5be2abb41e8768ed8bcdb17a9308c.png";